<div class="card-principal">
  <ng-container *ngIf="loading; else mostrarSS">
    <div class="spinnerSS">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <br>
      <strong>Espere un momento por favor...</strong>
    </div>
  </ng-container>
  <ng-template #mostrarSS>
    <p class="c-seguimiento_titulo">Número de seguimiento</p>
    <input type="text" #codigoSS class="c-seguimiento-serie" [value]="dataResumen.data.codigo" readonly>
    <button class="btn-secondary-tbk-exito centrar-btn" (click)="copiarCodigo(codigoSS)">Copiar número</button>
    <p class="info-seguimiento">Puedes hacer el seguimiento de tu solicitud con tu <strong>RUT</strong> y el número de seguimiento desde:
    </p>
    <p class="url-seguimiento"><a [href]="dataResumen.data.url" target="_blank" rel="noopener noreferrer">{{dataResumen.data.url}}</a></p>
    <ng-container *ngIf="esRiesgoso">
      <app-messages class="informativoSS mt-16 mb-16 p-16" message="Si tienes dudas o consultas llamanos desde celulares al <strong>+56 2 2661 27 00</strong> o desde teléfonos fijos al <strong>600 638 6380</strong>."></app-messages>
    </ng-container>
  </ng-template>
</div>
